import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { AppBar, IconButton, Theme, Toolbar, Typography } from '@material-ui/core';
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

interface SubHeaderProps {
    leftButtonClick: any,
    showRules: any,
    title: string
};

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        flexGrow: 1
    },
    menuButton: {
        marginLeft: theme.spacing(1),
        paddingLeft:0,
        "&:hover": {
            backgroundColor: "transparent"
        }
    },
}));

const SubHeader: React.FC<SubHeaderProps> = ({ leftButtonClick, showRules, title = "All Hospitals" }) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <AppBar position="static" style={{ backgroundColor: "#01224A" }}>
                <Toolbar variant="dense" style={{ justifyContent: "space-between" }}>
                    <span
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center"
                        }}
                    >
                        <Typography
                            variant="h6"
                            style={{ color: "#FFF", fontSize: 18, fontWeight: 400, cursor: "pointer" }}
                            onClick={leftButtonClick}
                        >
                            {title}
                        </Typography>
                        {showRules.hospitalSelectArrow && <IconButton
                            edge="start"
                            className={classes.menuButton}
                            color="inherit"
                            aria-label="menu"
                            onClick={leftButtonClick}
                        >
                            <KeyboardArrowDownIcon />
                        </IconButton>}
                    </span>
                </Toolbar>
            </AppBar>
        </div>
    );
}

export default SubHeader;